export interface RegionalLink {
    name: string;
    href: string;
}

export const regionalLinks: RegionalLink[] = [
    { name: "Christchurch", href: "https://www.canterburycoc.com/" },
    { name: "Newcastle", href: "http://www.newcastlechurchofchrist.org/" },
    { name: "Sydney", href: "https://www.sydneychurchofchrist.org/" },
    { name: "Gold Coast", href: "https://www.gcchurch.net/" },
    { name: "Brisbane", href: "https://www.brisbanechristianchurch.org/" },
    { name: "Melbourne", href: "https://www.melbournecoc.org/" },
    { name: "Perth", href: "https://www.perthcoc.com/" },
    { name: "Adelaide", href: "https://adelaidecoc.org.au/" },
    { name: "Port Moresby", href: "https://www.facebook.com/pomicoc" },
    { name: "Fiji", href: "https://www.facebook.com/fijichurchofchrist/" },
    { name: "South Pacific Region", href: "https://www.spachurches.com/" },
    { name: "Regional Church Locator", href: "https://www.google.com/maps/d/u/0/viewer?mid=1hlsH6t6VcGJRNNujLxYs8Tn0gQ8jnhLT&ll=-22.93259561865465%2C147.1589872&z=4" },
    { name: "School of Missions", href: "https://www.spachurches.com/mta.html" },
];
